import React from 'react';
import * as ht from './_ht';

//import * as rcl from './_csRcl';

import { useGblz } from './_csGbl';

/*
const _clrz = rcl.grtAtom('clrz', {
  mode: 'light',
});
*/
const _gClrz = useGblz('clr', {
  mode: 'light',
});

const _tblz = { // https://docs.nativebase.io/default-theme
  rdz: { // red
//    1: '#fee2e2',
    1: '#ffb5cd',
    2: '#fecaca',
    3: '#fca5a5',
    4: '#f87171',
    5: '#ef4444',
    6: '#dc2626',
    7: '#b91c1c',
    8: '#991b1b',
    9: '#7f1d1d',
  },
  gnz: { // green
    1: '#dcfce7',
    2: '#bbf7d0',
    3: '#86efac',
    4: '#4ade80',
    5: '#22c55e',
    6: '#16a34a',
    7: '#15803d',
    8: '#166534',
    9: '#14532d',
  },
  lmz: { // lime
    1: '#ecfccb',
    2: '#d9f99d',
    3: '#bef264',
    4: '#a3e635',
    5: '#84cc16',
    6: '#65a30d',
    7: '#4d7c0f',
    8: '#3f6212',
    9: '#365314',
  },
  blz: { // blue
    1: '#dbeafe',
//    2: '#bfdbfe',
    2: '#b7d8f9',
    3: '#93c5fd',
//    4: '#60a5fa',
    4: '#78b7f4',
    5: '#3b82f6',
    6: '#2563eb',
    7: '#1d4ed8',
//    8: '#1e40af',
    8: '#00a3d9',
//    9: '#1e3a8a',
    9: '#003366',
  },
  ltz: { // light
//    1: '#f3f4f6',
    1: '#ffffff',
    2: '#e5e7eb',
    3: '#d1d5db',
    4: '#9ca3af',
    5: '#6b7280',
//    6: '#4b5563',
    6: '#444444',
    7: '#374151',
    8: '#1f2937',
    9: '#111827',
  },
  skz: { // smoke
    1: 'rgba(0,0,0,0.1)',
    2: 'rgba(0,0,0,0.2)',
    3: 'rgba(0,0,0,0.3)',
    4: 'rgba(0,0,0,0.4)',
    5: 'rgba(0,0,0,0.5)',
    6: 'rgba(0,0,0,0.6)',
    7: 'rgba(0,0,0,0.7)',
    8: 'rgba(0,0,0,0.8)',
    9: 'rgba(0,0,0,0.9)',
  },
  ywz: { // yellow
    1: '#fef9c3',
//    2: '#fef08a',
    2: '#fff14d',
    3: '#fde047',
    4: '#facc15',
    5: '#eab308',
    6: '#ca8a04',
    7: '#a16207',
    8: '#854d0e',
    9: '#713f12',
  },
} as ht.dz;

let _cashz = {} as ht.dz;

export const useClrz = () => {

/*
  React.useEffect(() => {
    _cashz = {};
  }, [
    _gClrz.crt.mode
  ]);
*/

  const _c = (
    pTgt: ht.s, 
  ) => {

    if (_cashz[pTgt]) return _cashz[pTgt];

    let _clr = 'red';

    if (pTgt == 't') {
      _clr = 'transparent';
    }
    else {
//      const _type = `${pTgt[0]}z`;
      const _type = `${pTgt.substring(0,2)}z`;
      //console.log(`csClr 113: ${_type}`)
      if (_tblz[_type]) {
//        const _nLvl = ((_dz.crt.mode == 'dark') ? (10 - Number(pTgt[1])) : Number(pTgt[1])); // colorMode を使用する場合、level を反転させれば良い
//        const _nLvl = ((_dz.crt.mode == 'dark') ? (10 - Number(pTgt[2])) : Number(pTgt[2])); // colorMode を使用する場合、level を反転させれば良い
        const _nLvl = ((_gClrz.crt.mode == 'dark') ? (10 - Number(pTgt[2])) : Number(pTgt[2])); // colorMode を使用する場合、level を反転させれば良い
        if (_tblz[_type][_nLvl]) {
          _clr = _tblz[_type][_nLvl];
        }
      }
    }
    _cashz[pTgt] = _clr;
    return _clr;
  };
  return {
//    ..._dz,
    ... _gClrz,
    set: (_dz: ht.dz) => {
      _cashz = {};
      _gClrz.set(_dz);
    },
    c: _c,
  }
}
